import { render, staticRenderFns } from "./Lti.vue?vue&type=template&id=2fcd1000"
import script from "./Lti.vue?vue&type=script&lang=js"
export * from "./Lti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports